import React from 'react';

import {
  PeerFeedbackMindsetRatingInputType,
  PeerFeedbackSkillRatingInputType,
} from '@/types/schema';

import RelatedMindset from './RelatedMindset';
import RelatedSkill from './RelatedSkill';

function RelatedSkillsOrMindsets(props: {
  onChange: (
    value: PeerFeedbackSkillRatingInputType[] | PeerFeedbackMindsetRatingInputType[],
  ) => void;
  skillRatings: PeerFeedbackSkillRatingInputType[] | PeerFeedbackMindsetRatingInputType[];
  userId?: string;
  isMindset?: boolean;
}) {
  if (props.isMindset) {
    return (
      <RelatedMindset
        {...props}
        skillRatings={props.skillRatings as PeerFeedbackMindsetRatingInputType[]}
      />
    );
  }
  return (
    <RelatedSkill
      {...props}
      skillRatings={props.skillRatings as PeerFeedbackSkillRatingInputType[]}
    />
  );
}

export default RelatedSkillsOrMindsets;
